<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>Surat</h3>
        </div>
    </div>
</header>
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" placeholder="શોધો" />
                <i class="ti ti-search"></i>
            </form>
            <i class="ti ti-filter"></i>
        </div>
    </div>
    <div class="city-list">
        <div class="main-members">
            <a routerLink="/city/area-details" class="member-list-item">
                <div>
                    <h5>Bhatar</h5>
                    <p>T. Surat | 2k people</p>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a routerLink="/city/area-details" class="member-list-item">
                <div>
                    <h5>Althan</h5>
                    <p>T. Surat | 150 people</p>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a routerLink="/city/area-details" class="member-list-item">
                <div>
                    <h5>City Light</h5>
                    <p>T. Surat | 12 people</p>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a routerLink="/city/area-details" class="member-list-item">
                <div>
                    <h5>Pipload</h5>
                    <p>T. Surat | 200 people</p>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
        </div>
    </div>
</main>